const workspaceQuery = (workspace?: string) => (workspace ? `?workspace=${encodeURIComponent(workspace)}` : '');

/** The hiring form's path for an employee not on the shelf. */
export const customRole = 'custom';

/** Every path in the app, in one place. `/items/:id` is the same deep link the mobile app has. */
export const Routes = {
  login: '/login',
  inbox: '/inbox',
  /** An item next to the inbox list on wide screens. */
  inboxItem: (id: string) => `/inbox/${id}`,
  team: '/team',
  employee: (id: string) => `/team/employees/${id}`,
  /** The shelf of employees to ask for (ADR 0010); `workspace` (a slug) preselects the business. */
  hire: (workspace?: string) => `/team/hire${workspaceQuery(workspace)}`,
  /** Asking for one module, or for someone not on the shelf (`custom`). */
  hireModule: (role: string, workspace?: string) => `/team/hire/${encodeURIComponent(role)}${workspaceQuery(workspace)}`,
  history: '/history',
  settings: '/settings',
  item: (id: string) => `/items/${id}`,
} as const;
